<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-11 00:50 -->
<!-- Description:  -->
<template>
  <div>
    <div class="d-flex mb-3">
      <select name="" id="" multiple v-model="leftSelect" class="col-5">
        <option v-for="(l1) in leftList" :key="l1.id" :value="l1.id">{{ l1.slug }}</option>
      </select>
      <div class="col-2">
        <button class="btn btn-sm btn-light d-block" @click="handleToLeft()">
          <i class="fas fa-arrow-left"></i>
        </button>
        <button class="btn btn-sm btn-light d-block" @click="handleToRight()">
          <i class="fas fa-arrow-right"></i>
        </button>
      </div>
      <select name="" id="" multiple v-model="rightSelect" class="col-5">
        <option v-for="(l2) in rightList" :key="l2.id" :value="l2.id">{{ l2.slug }}</option>
      </select>
    </div>
    <button class="btn btn-sm btn-primary mb-3" @click="save()">Guardar</button>
    <div class="alert alert-success" v-show="saved">
      Permisos guardados
    </div>
  </div>
</template>
<script>
import AdminService from "../AdminService.js";
// script content
export default {
  name: "RolePermissions",
  components: {
    //
  },

  // directives

  props: {
    roleId: {
      require: true,
    }
  },

  data: () => ({
    leftList: [],
    rightList: [],
    leftSelect: [],
    rightSelect: [],
    saved: false,
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    this.reload();
  },

  methods: {
    handleModel(ev) {
      //
    },
    async reload() {
      this.loading = true;
      let [res, res2] = await Promise.all([
        AdminService.getPermissions({per_page: 999}),
        AdminService.getPermissions({role_id: this.roleId, per_page: 999})
      ]);
      this.leftList = res.data;
      this.rightList = res2.data;
      this.leftSelect = [];
      this.rightSelect = [];
    },
    handleToRight() {
      // add selected items in left to right, check if exists, dont send duplicate, check duplicate with id
      for(let it of this.leftSelect) {
        if(!this.rightList.find(item => item.id === it)) {
          this.rightList.push(
            this.leftList.find(item => item.id === it)
          );
        }
      }
    },
    handleToLeft() {
      // remove selected items in right to left, check if exists, dont send duplicate, check duplicate with id
      for(let it of this.rightSelect) {
        if(this.rightList.find(item => item.id === it)) {
          this.rightList = this.rightList.filter(item => item.id !== it);
        }
      }
    },
    async save() {
      this.saved = false;
      let res = await AdminService.saveRolePermissions({
        role_id: this.roleId,
        permissions: this.rightList.map(item => item.id)
      });
      this.$emit('saved', res);
      this.saved = true;
    },
    //
    //
  }
};
</script>
<style scoped></style>
